import React from 'react';
import { Box, Heading, Text } from '@indeed/ifl-components';

interface JobPreferenceFieldProps {
    label: string;
    value: string;
    icon: React.ReactNode;
}

/**
 * JobPreferenceField Component
 * Displays a preference field with an icon, label, and value
 * Used in the job preferences card to show match criteria
 */
export const JobPreferenceField: React.FC<JobPreferenceFieldProps> = ({ label, value, icon }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                gap: 3,
                alignItems: 'flex-start',
            }}
        >
            <Box
                sx={{
                    color: 'foreground.strong',
                    flexShrink: 0,
                }}
            >
                {icon}
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                }}
            >
                <Text level={2}>{label}</Text>
                <Heading level={3}>{value}</Heading>
            </Box>
        </Box>
    );
};
